import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames/bind'

import styles from './textarea_input.scss'
import CajaDecorator from 'decorators/caja/caja_decorator'


class TextareaInput extends Component {

	shouldComponentUpdate(nextProps) {
		return this.props.value !== nextProps.value
	}

	render() {

		const cx = classNames.bind(styles)
		const classValue = cx({
			block: true,
			disabled: this.props.disabled,
		})

		return (
			<textarea
				maxLength={this.props.maxLength}
				placeholder={this.props.placeholder}
				type={this.props.type}
				name={this.props.name}
				value={this.props.value}
				onBlur={this.props.onBlur}
				onChange={this.props.onChange}
				onFocus={this.props.onFocus}
				disabled={this.props.disabled}
				tabIndex={this.props.tabIndex}
				className={classValue}
			/>
		)
	}
}

TextareaInput.defaultProps = {
	autoComplete: 'off',
	disabled: false,
}

TextareaInput.propTypes = {
	maxLength: PropTypes.string,
	placeholder: PropTypes.string,
	type: PropTypes.string,
	name: PropTypes.string,
	disabled: PropTypes.bool,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	tabIndex: PropTypes.number,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	autoComplete: PropTypes.string,
}

export default CajaDecorator(TextareaInput)
